import {
  GeneralDataTypes, HeaderFooterDataTypes, IRequestDemo, TContactForm, TContactProblemData
} from './type';

import axiosInstance from 'services/common/instance';

export const getProblemsService = async (): Promise<TContactProblemData[]> => {
  const res = await axiosInstance.get('contact-problems');
  return res.data.data;
};

export const getHeaderFooterService = async (): Promise<HeaderFooterDataTypes> => {
  const res = await axiosInstance.get('systems/header-footer');
  return res.data?.data;
};

export const postContactService = async (data: TContactForm): Promise<APIResponse<any>> => {
  const res = await axiosInstance.post('contacts', { ...data });
  return res.data;
};

export const requestDemoService = async (data: IRequestDemo): Promise<IRequestDemo> => {
  const response = await axiosInstance.post('demo-subscribe', data);
  return response.data.data;
};

export const getGeneralService = async (): Promise<GeneralDataTypes> => {
  const res = await axiosInstance.get('systems/general');
  return res.data?.data;
};
